import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Grid } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import { DangerZoneCard } from '~/common/components'
import { ServicepointVendorDetails, ServicepointVendorDangerZoneDialog } from '~/modules/servicepointvendors/components'
import { useServicepointVendor } from '~/modules/servicepointvendors/hooks'
import { BackButton } from '~/temp-ds-component/BackButton'

type Params = {
  id: string
}

export const ServicepointVendorDetailsPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [dangerZoneOpen, setDangerZoneOpen] = useState<boolean>(false)
  const { id: userId } = useParams<Params>()

  const dangerZoneContent = {
    title: t('admin.servicePointVendorsPage.servicePointVendorsDangerZone.header'),
    subtitle: t('admin.servicePointVendorsPage.servicePointVendorsDangerZone.subHeader'),
    value: t('admin.servicePointVendorsPage.servicePointVendorsDangerZone.message'),
    button: t('admin.servicePointVendorsPage.servicePointVendorsDangerZone.deleteButton'),
    id: userId,
  }

  const { servicepoint } = useServicepointVendor(userId)

  const onClickOpen = () => {
    userId && setDangerZoneOpen(true)
  }

  const onBack = () => navigate(links.servicePointVendorsLink())

  return (
    <>
      <Grid>
        <Box marginBottom={2}>
          <BackButton onClick={onBack}>
            {t('admin.servicePointVendorsPage.servicePointVendorsForm.backButtonTitle')}
          </BackButton>
        </Box>
      </Grid>
      <Grid size={{ sm: 6 }}>{servicepoint && <ServicepointVendorDetails servicepoint={servicepoint} />}</Grid>
      <Grid size={{ sm: 6 }}>
        <Box marginTop={3}>
          <DangerZoneCard dangerZoneContent={dangerZoneContent} onClickOpen={onClickOpen} />
        </Box>
      </Grid>

      {userId && (
        <ServicepointVendorDangerZoneDialog
          open={dangerZoneOpen}
          userId={userId}
          onClose={() => setDangerZoneOpen(false)}
        />
      )}
    </>
  )
}
